import { useMemo } from 'react';

import { parseDataFieldSections } from '~/components/Workflow/Workflow.utils';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { api } from '~/redux/api/createApi';
import { AllDataFields, FieldSectionsResponse } from '~/types/DataFieldSection';

export const useDataFieldSection = () => {
  const client = useCurrentUser()?.client;

  const { data, isFetching } = api.endpoints.getDataFieldSections.useQuery(
    client,
    {
      skip: !client,
    },
  ) as FieldSectionsResponse;

  const allDataFields: AllDataFields = useMemo(() => {
    return parseDataFieldSections(data) as AllDataFields;
  }, [data]);

  return { allDataFields, isFetching };
};
